import { render, staticRenderFns } from "./BracketFinalWinner.vue?vue&type=template&id=3e978880&"
import script from "./BracketFinalWinner.vue?vue&type=script&lang=js&"
export * from "./BracketFinalWinner.vue?vue&type=script&lang=js&"
import style0 from "./BracketFinalWinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports